import { render, staticRenderFns } from "./magic-branding-button-widget.vue?vue&type=template&id=21094ada&"
import script from "./magic-branding-button-widget.vue?vue&type=script&lang=js&"
export * from "./magic-branding-button-widget.vue?vue&type=script&lang=js&"
import style0 from "./magic-branding-button-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports